<template>
    <div class="container table-data">
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="学校名称" prop="school_id">
                <el-select v-model="queryForm.school_id" filterable placeholder="请选择">
                    <el-option
                        v-for="item in schoolList"
                        :key="item.school_id"
                        :label="item.school_name"
                        :value="item.school_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in tableColumn"
                :prop="item.id"
                :label="item.name"
                :show-overflow-tooltip="true"
                :key="index"
                :width="item.width"
                :fixed="item.fixed">
                <template slot-scope="scope">
                    <span v-if="item.formatter">{{ item.formatter(scope.row) }}</span>
                    <span v-else>{{ scope.row[item.id] }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="code"
                    label="门店二维码"
                    :show-overflow-tooltip="true"
                    fixed="right">
                <template slot-scope="scope">
                    <span class="primary cursor" @click="loadShopCode(scope.row)">门店二维码下载</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.page"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import * as _ from "lodash";

export default {
    name: "shopList",
    data () {
        return {
            queryFormLabelWidth: '100px', // 自定义查询表单label宽度
            queryForm: {
                school_id: '', // 学校id
                page: 1,
                pageSize: 10,
            },
            schoolList: [],
            accountInfo: {},
            total: 0,
            pageSizes: [10,20,30,40,50], // 自定义分页条数
            loading: false,
            tableColumn: [
                { name: '门店名称', id: 'shop_name', fixed: false, },
                {
                    name: '学校名称',
                    id: 'school_name',
                    fixed: false,
                    formatter: (row) => {
                        let arr = this.schoolList.filter(item => item.school_id == row.school_id)
                        return arr.length ? arr[0].school_name : '';
                    }
                },
                { name: '城市', id: 'district_name', fixed: false, },
                { name: '地址', id: 'address', width: '150', fixed: false, },
                {
                    name: '合作状态',
                    id: 'is_cooperate',
                    fixed: false,
                    formatter: (row) => {
                        return row.is_cooperate ? '开业' : '歇业';
                    }
                }
            ],
            tableData: [],
        }
    },
    methods: {
        /** 切换每页显示条数操作 */
        handleSizeChange(val) {
          this.queryForm.page = 1;
          this.queryForm.pageSize = val;
          this.fetchData();
        },
        /** 分页器触发 */
        handleCurrentChange (val) {
          this.queryForm.page = val;
          this.fetchData();
        },
        /** 获取学校列表 */
        getSchoolList () {
            let params = {
                commercial_ids: this.accountInfo.companyIds ? this.accountInfo.companyIds : '',
                // school_name: null
            }
            this.$api.post(this.$apiUrl.commercialSchoolsList, params,(res)=>{
                if (res.message == "success" && res.result) {
                    this.schoolList = res.data;
                } else {
                    this.$message.warning(res.message);
                    this.schoolList = [];
                }
                this.fetchData();
            },(res)=>{
                this.$message.warning(res.message);
                this.schoolList = [];
            })
        },
        /** 获取数据 */
        fetchData () {
            this.loading = true;
            let params = { ...this.queryForm };
            params.type = this.accountInfo.pid ? 2 : 1;
            params.commercial_ids = this.accountInfo.companyIds ? this.accountInfo.companyIds : '';
            params.school_ids = this.accountInfo.schoolIds ? this.accountInfo.schoolIds : '';
            this.$apiOuter.post(this.$apiUrl.commercialShopList, params,(res)=>{

                if (res.message == "success" && res.result) {
                    this.total = res.data.total;
                    this.tableData = res.data.list;
                } else {
                    this.$message.warning(res.message);
                    this.total = 0;
                    this.tableData = [];
                }
                this.loading = false;
            },(res)=>{
                this.$message.warning(res.message);
                this.loading = false;
                this.total = 0;
                this.list = [];
                this.tableData = [];
            },'merchants')
        },
        /** 重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.fetchData();
        },
        loadShopCode(item) {
            console.log(item)
            this.$apiOuter.post(this.$apiUrl.shopQr, {school_id: item.school_id, shop_id: item.id},(res)=>{
                window.open(res.data);
            },(res)=>{
                this.$message.warning(res.message);
            },'merchants')
        }
    },
    created() {
        this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
        this.getSchoolList();
    },
    mounted () {
        // this.fetchData();
    }
}
</script>

<style scoped lang="scss">
      .table-data .el-table{
          -webkit-text-size-adjust: none;
      }
</style>


// WEBPACK FOOTER //
// list.vue?3cf5a772